import { Trans } from '@lingui/react/macro';

import { ActivityOfType } from '@/components/activities/Activity';
import { BaseActivity, BaseActivityText } from '@/components/activities/BaseActivity/BaseActivity';
import IconPackageIssue from '@/icons/PackageIssue.svg';

export const ArticleExchangeStockAvailabilityRefusedActivity = ({
  activity,
}: {
  activity: ActivityOfType<'article_exchange_stock_availability_refused'>;
}) => {
  const stockLocationName = activity.entity.name;
  const creatorName = activity.creator.name;
  const productName = activity.data.replacementProduct.name;

  return (
    <BaseActivity
      createdAt={activity.createdAt}
      type="warning"
      icon={<IconPackageIssue />}
      message={
        <BaseActivityText>
          {activity.data.onBehalfOfStockLocation ? (
            <Trans id="activities.article_exchange_stock_availability_refused.message.on-behalf">
              <strong>{creatorName}</strong> reported product {productName} as out of stock on
              behalf of {stockLocationName}.
            </Trans>
          ) : (
            <Trans id="activities.article_exchange_stock_availability_refused.message">
              <strong>{creatorName}</strong> reported product {productName} as out of stock.
            </Trans>
          )}
        </BaseActivityText>
      }
    />
  );
};
